import { AuthProvider } from './context/AuthContext';
import { useAuth } from './context/AuthContext';
import AppRoutes from './routes/AppRoutes';

function LoadingScreen() {
  return (
    <div className="loading-screen">
      <div className="spinner spinner-lg" />
      <p>Loading Tatsavi Spaces…</p>
    </div>
  );
}

function AppContent() {
  const { loading } = useAuth();
  if (loading) return <LoadingScreen />;
  return <AppRoutes />;
}

export default function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}